const { objectOperator } = require('../agent/utils/spread');
const commons = require('./commons');
const {
  WINDOW_DOM,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
} = require('./metrics');

const metrics = [WINDOW_DOM, WINDOW_WIDTH, WINDOW_HEIGHT];

module.exports = objectOperator([commons, { endpoint: 'https://events.mercadolibre.com/dom', metrics }]);
